function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Accounts = /*#__PURE__*/function () {
  function Accounts(app, mod) {
    _classCallCheck(this, Accounts);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(Accounts, [{
    key: "getCredentials",
    value: function getCredentials() {
      var _this$mod;
      return (_this$mod = this.mod) !== null && _this$mod !== void 0 && _this$mod.credentials && _typeof(this.mod.credentials) === 'object' ? this.mod.credentials : {};
    }
  }, {
    key: "saveCredentials",
    value: function saveCredentials(credentials) {
      var next = credentials && _typeof(credentials) === 'object' ? _objectSpread({}, credentials) : {};
      delete next.api_key;
      delete next.deposit_addresses;
      delete next.operation_mode;
      delete next.execution_mode;
      delete next.admin_choice;
      delete next.fulfillment_mode;
      delete next.payout_mode;
      delete next.treasury_provider_publickeys;
      delete next.treasury_delegate_publickeys;
      this.mod.credentials = next;
      this.mod.account_created = next.user_id ? 1 : 0;
      this.mod.save();
    }
  }, {
    key: "areCredentialsDeprecated",
    value: function areCredentialsDeprecated(credentials) {
      return typeof (credentials === null || credentials === void 0 ? void 0 : credentials.pin_token_base64) !== 'undefined';
    }
  }, {
    key: "encryptCredentials",
    value: function encryptCredentials(credentials, publicKey) {
      var buf = Buffer.from(JSON.stringify(credentials), 'utf8');
      return this.app.crypto.encryptWithPublicKey(buf, publicKey).toString('base64');
    }
  }, {
    key: "decryptCredentials",
    value: function decryptCredentials(ciphertext, privateKey) {
      var decrypted = this.app.crypto.decryptWithPrivateKey(Buffer.from(ciphertext, 'base64'), privateKey);
      return JSON.parse(decrypted.toString('utf8'));
    }
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(publicKey) {
        var options,
          existing,
          credentials,
          ciphertext,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              if (!((options === null || options === void 0 ? void 0 : options.additional) !== true)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return this.mod.database.getCredentials(publicKey);
            case 1:
              existing = _context.v;
              if (!existing.length) {
                _context.n = 2;
                break;
              }
              return _context.a(2, {
                ciphertext: existing[0].ciphertext,
                restored: true,
                user_id: existing[0].user_id
              });
            case 2:
              _context.n = 3;
              return this.mod.api.createAccount("Saito User ".concat(publicKey));
            case 3:
              credentials = _context.v;
              ciphertext = this.encryptCredentials(credentials, publicKey);
              _context.n = 4;
              return this.mod.database.saveCredentials(publicKey, ciphertext, credentials.user_id);
            case 4:
              return _context.a(2, {
                ciphertext: ciphertext,
                restored: false,
                user_id: credentials.user_id
              });
          }
        }, _callee, this);
      }));
      function createAccount(_x) {
        return _createAccount.apply(this, arguments);
      }
      return createAccount;
    }()
  }, {
    key: "createAddress",
    value: function () {
      var _createAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(assetId, chainId) {
        var credentials,
          selected,
          address,
          _find,
          ticker,
          _this$mod$mixin_peer,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              credentials = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
              selected = credentials || this.getCredentials();
              if (selected !== null && selected !== void 0 && selected.user_id) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, false);
            case 1:
              _context2.n = 2;
              return this.mod.api.createAddress(selected, chainId);
            case 2:
              address = _context2.v;
              if (address) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, false);
            case 3:
              _context2.n = 4;
              return this.mod.database.insertAddress({
                mixinUserId: selected.user_id,
                publicKey: this.mod.publicKey,
                assetId: assetId,
                address: address,
                createdAt: Date.now()
              });
            case 4:
              if (!this.app.BROWSER && typeof this.mod.rememberDepositAddress === 'function') {
                ticker = ((_find = (this.mod.crypto_mods || []).find(function (item) {
                  return item.asset_id === assetId;
                })) === null || _find === void 0 ? void 0 : _find.ticker) || '';
                this.mod.rememberDepositAddress({
                  address: address,
                  assetId: assetId,
                  ticker: ticker,
                  mixinUserId: selected.user_id
                });
              }
              if (this.app.BROWSER) {
                this.app.network.sendRequestAsTransaction('mixin save new deposit address', {
                  user_id: selected.user_id,
                  asset_id: assetId,
                  address: address,
                  publickey: this.mod.publicKey
                }, function (res) {
                  console.log('Callback for mixin save new deposit address: ', res);
                }, (_this$mod$mixin_peer = this.mod.mixin_peer) === null || _this$mod$mixin_peer === void 0 ? void 0 : _this$mod$mixin_peer.publicKey);
              }
              return _context2.a(2, address);
          }
        }, _callee2, this);
      }));
      function createAddress(_x2, _x3) {
        return _createAddress.apply(this, arguments);
      }
      return createAddress;
    }()
  }]);
}();
module.exports = Accounts;